import React, {useState} from "react";
import Table from "../../../components/Table/Table";
import {useLocation, useNavigate} from "react-router-dom";
import {useGetUsers} from "../../../hooks/Sysadmin/useGetUsers";
import "./SysadminDashboard.css";
import SearchTicketModal from "../../../components/SearchTicketModal/SearchTicketModal";
import {UserFilters} from "../../../services/Sysadmin/getUsers";
import FilterUserModal from "../../../components/FilterUserModal/FilterUserModal";
import {useGetUserDetails} from "../../../hooks/Sysadmin/useGetUserDetails";
import UserDetailsContent from "../../../components/UserDetails/UserDetails";

const columns = ["USUARIO", "NOMBRE", "ROL", "ESTADO"];

const SysadminDashboard = () => {
    const [isSearchModalVisible, setSearchModalVisible] = useState(false);
    const [isFilterModalVisible, setFilterModalVisible] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [filters, setFilters] = useState<UserFilters>({});
    const clearFilters = () => setFilters({});
    const [disableEdit, setDisableEdit] = useState(true);
    const {userDetails, fetchUserDetails, isUserDetailsLoading, setUserDetails} =
        useGetUserDetails();
    const {users, totalPages, isLoading, page, setPage} = useGetUsers({
        filters, clearFilters
    });

    const handleAddUser = () => {
        const pathArray = location.pathname.split("/");
        pathArray[pathArray.length - 1] = "users";
        const newPath = pathArray.join("/");
        navigate(newPath);
    };

    const resetUsersTable = () => {
        setFilters({});
        setUserDetails(null);
    };

    const handleCloseSearchModal = () => {
        setSearchModalVisible(false);
    };

    const handleSearchModal = (username: string) => {
        setFilters({username});
    };

    const handleUserFilterModal = (newFilters: any) => {
        if (JSON.stringify(newFilters) !== JSON.stringify(filters)) {
            setPage(0);
        }
        setFilters(newFilters);
    };

    const handleFilterIconClick = () => {
        setFilterModalVisible(true);
    };

    const handleOnRowClick = (row: Record<string, any>) => {
        setDisableEdit(true);
        fetchUserDetails(row.USUARIO);
    };

    return (
        <div className={`sysadmin-users-container`}>
            {isLoading ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">
                        Obteniendo información...
                    </div>
                </div>
            ) : (
                <div className="sysadmin-users-container-wrapper">
                    <div className="sysadmin-users-header">
                        <div className="sysadmin-users-header-title">
                            <p>USUARIOS</p>
                        </div>
                        <span
                            className="material-icons-outlined sysadmin-icon"
                            onClick={() => setSearchModalVisible(true)}
                        >
                            search
                        </span>
                        <span
                            className="material-icons-outlined sysadmin-icon"
                            onClick={handleAddUser}
                        >
                            add_box
                        </span>
                        <span
                            className="material-icons-outlined sysadmin-icon"
                            onClick={handleFilterIconClick}
                        >
                            filter_alt
                        </span>
                        <span
                            className="material-icons-outlined sysadmin-icon"
                            onClick={resetUsersTable}
                        >
                            restart_alt
                        </span>
                    </div>
                    <div className="sysadmin-users-wrapper-content">
                        <div className="sysadmin-table-container">
                            <Table
                                columns={columns}
                                data={users}
                                totalPages={totalPages}
                                currentPage={page}
                                setCurrentPage={setPage}
                                onRowClick={handleOnRowClick}
                            />
                        </div>
                        <UserDetailsContent
                            userDetails={userDetails}
                            isUserDetailsLoading={isUserDetailsLoading}
                            disableEdit={disableEdit}
                            setDisableEdit={setDisableEdit}
                            onComplete={resetUsersTable}
                        />
                    </div>
                </div>
            )}

            <SearchTicketModal
                isVisible={isSearchModalVisible}
                onClose={handleCloseSearchModal}
                onSearch={handleSearchModal}
                placeholder="Usuario"
            />

            <FilterUserModal
                isVisible={isFilterModalVisible}
                onSearch={handleUserFilterModal}
                onClose={() => setFilterModalVisible(false)}
            />
        </div>
    );
};

export default SysadminDashboard;
